import { QrCode, Car } from 'lucide-react'
import { Button } from '@/components/ui/button'

export default function ScanMethodSelector({ onSelectQr, onSelectPlate, disabled }) {
  return (
    <div className="space-y-4">
      <p className="text-sm font-medium text-foreground text-center">
        How would you like to identify the customer?
      </p>
      <div className="grid gap-3">
        <Button
          type="button"
          className="h-14 w-full text-base justify-start gap-3 px-4"
          onClick={onSelectQr}
          disabled={disabled}
        >
          <QrCode className="size-6 shrink-0" />
          Scan Customer QR
        </Button>
        <div className="flex items-center gap-3 px-1">
          <div className="h-px flex-1 bg-border" />
          <span className="text-xs text-muted-foreground uppercase tracking-wide">or</span>
          <div className="h-px flex-1 bg-border" />
        </div>
        <Button
          type="button"
          variant="secondary"
          className="h-14 w-full text-base justify-start gap-3 px-4"
          onClick={onSelectPlate}
          disabled={disabled}
        >
          <Car className="size-6 shrink-0" />
          Scan Licence Plate
        </Button>
      </div>
    </div>
  )
}
